import styled from 'styled-components';

import { FocusButton } from '@main/pc-core-components';
import { sp } from '@main/theme';

/**
 * Language options wrapper
 */
export const OptionsWrapper = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

/**
 * Styled option wrapper
 */
export const StyledOption = styled(FocusButton)<{
  /** Whether the option is currently selected */
  $current: boolean;
}>`
  font-family: '${({ theme }) => theme.textStyles.fontFamilyHeader.name}';
  color: ${({ theme, $current }) =>
    $current ? theme.colors.primary : theme.colors.transcendNavy2};
  padding: ${sp(0.8)} ${sp(1)};
  border-radius: 6px;
  width: 100%;
  text-align: left;

  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme.colors.gray1};
    box-shadow: none;
  }

  &:active {
    color: ${({ theme, $current }) =>
      $current ? theme.colors.primary : theme.colors.transcendNavy2};
  }
`;

/**
 * Styled main toggle button wrapper
 */
export const StyledButton = styled(FocusButton)`
  font-family: '${({ theme }) => theme.textStyles.fontFamilyHeader.name}';
  color: ${({ theme }) => theme.colors.secondary};
  display: flex;
  align-items: center;
  padding: ${sp(0.5)};

  &:hover,
  &:focus {
    opacity: 0.7;
  }
`;
